import React from "react";

import Heartbeat from "ZeroRuby/snippets/heartbeat";

import { Card } from "Common/Card";
import Footer from "Common/Footer";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import ResponsiveTopBar from "Common/TopBar/ResponsiveTopBar";

type Props = {
  children: React.ReactNode;
  variant: "single" | "multi";
};

const Chrome = ({ variant = "single", ...rest }: Props) => {
  const props = variant === "single" ? { componentClass: Card, mt: 5 } : {};
  return (
    <div>
      <ResponsiveTopBar />
      <Div className="min-h-dvh">
        <Grid {...props} {...rest} />
      </Div>
      <Footer />
      <Heartbeat />
    </div>
  );
};

export default Chrome;
